import React, { useEffect, useState } from "react";
import http from "../../../../services/http";

/** 27/10/2026 (Đợt 2): Chứng nhận chấp thuận của trạm — xem PDF (đường có gác quyền), gửi lại khi lỗi. */
type ChungNhan = {
	code: string;
	signerName: string;
	signerCapacity: string;
	documents: Array<{ title: string; versionLabel: string }>;
	emailStatus: string;
	emailedTo?: { to?: string[]; cc?: string[] } | null;
	hasPdf: boolean;
	createdAt: string;
	/** 02/11/2026: kết quả xét chữ ký (null = chưa xét). */
	review?: { status: "approved" | "rejected" | "void" | string; reason?: string | null } | null;
};
const MAU: Record<string, string> = { sent: "#067647", failed: "#B42318", pending: "#B54708", skipped: "#667085" };

export default function ChungNhanTram(props: { partnerId: string }) {
	const [ds, setDs] = useState<ChungNhan[]>([]);
	const [busy, setBusy] = useState("");
	const [loi, setLoi] = useState("");
	const tai = () =>
		http
			.get(`/admin/partners/${props.partnerId}/acceptance-certificates`)
			.then(({ data }) => setDs(data?.data || []))
			.catch(() => setDs([]));
	useEffect(() => {
		tai();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.partnerId]);
	const moPdf = async (code: string) => {
		const tab = window.open("", "_blank");
		try {
			const res = await http.get(`/admin/acceptance-certificates/${encodeURIComponent(code)}/pdf`, { responseType: "blob" });
			const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
			if (tab) tab.location.href = url;
		} catch {
			tab?.close();
			setLoi("Could not open the PDF.");
		}
	};
	const guiLai = async (code: string) => {
		setBusy(code);
		setLoi("");
		try {
			await http.post(`/admin/acceptance-certificates/${encodeURIComponent(code)}/retry`, {});
			await tai();
		} catch (e: any) {
			setLoi(e?.response?.data?.message || "Could not resend.");
		} finally {
			setBusy("");
		}
	};
	if (!ds.length) return null;
	return (
		<div data-testid="acceptance-certificates-admin" style={{ marginTop: 12, fontSize: 12.5, color: "#344054" }}>
			<strong>Acceptance certificates</strong>
			{ds.map((c) => (
				<div key={c.code} style={{ borderTop: "1px solid #EAECF0", padding: "6px 0", display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
					<span style={{ flex: "1 1 260px" }}>
						<strong style={c.review?.status === "void" ? { textDecoration: "line-through" } : undefined}>{c.code}</strong>
						{c.review?.status === "void" || c.review?.status === "rejected" ? (
							<span
								data-testid={`cert-${c.review.status}-${c.code}`}
								style={{ marginLeft: 6, padding: "1px 8px", borderRadius: 999, background: "#FEF3F2", color: "#B42318", fontWeight: 700 }}>
								{c.review.status === "void" ? "Void" : "Rejected"}
								{c.review.reason ? ` — ${c.review.reason}` : ""}
							</span>
						) : null}{" "}
						· {new Date(c.createdAt).toLocaleString()} · {c.signerName} (
						{c.signerCapacity === "authorised" ? "authorised" : "owner / representative"}) ·{" "}
						{c.documents.map((d) => `${d.title} v${d.versionLabel}`).join(", ")} ·{" "}
						<span style={{ color: MAU[c.emailStatus] || "#667085", fontWeight: 600 }}>
							email {c.emailStatus}
							{c.emailedTo?.to?.length ? ` → ${c.emailedTo.to.join(", ")}` : ""}
						</span>
					</span>
					{c.hasPdf ? (
						<button type="button" onClick={() => moPdf(c.code)} style={{ border: "1px solid #D0D5DD", background: "#fff", borderRadius: 8, padding: "4px 10px", cursor: "pointer" }}>
							View PDF
						</button>
					) : null}
					{c.emailStatus === "failed" || !c.hasPdf ? (
						<button type="button" disabled={busy === c.code} onClick={() => guiLai(c.code)} style={{ border: "none", background: "#0F5F9E", color: "#fff", borderRadius: 8, padding: "4px 10px", cursor: "pointer" }}>
							{busy === c.code ? "Sending…" : "Rebuild & resend"}
						</button>
					) : null}
				</div>
			))}
			{loi ? <div style={{ color: "#B42318" }}>{loi}</div> : null}
		</div>
	);
}
